import { PatientAllergiesConstants } from './patientAllergies.constants'
import { IPatientAllergiesAction, IPatientAllergiesState } from './patientAllergies.types'

export const initialPatientAllergiesState: IPatientAllergiesState = {
  isLoading: false,
  allergies: [],
  allergy: null,
}

export function patientAllergiesReducer(
  state: IPatientAllergiesState = initialPatientAllergiesState,
  action: IPatientAllergiesAction
): IPatientAllergiesState {
  switch (action.type) {
    case PatientAllergiesConstants.NOT_IMPLEMENTED:
      alert('Not implemented')
      return state
    case PatientAllergiesConstants.SET_IS_LOADING:
      return { ...state, isLoading: action.isLoading }
    case PatientAllergiesConstants.SAVE_ALLERGIES:
      action.allergies.map((pa) => (pa.selected = true))
      return { ...state, allergies: action.allergies }
    case PatientAllergiesConstants.SET_PATIENT_ALLERGIES:
      return { ...state, ...action.patientAllergies }
    case PatientAllergiesConstants.DELETE_ALLERGY:
      return { ...state, allergy: action.allergy }
    case PatientAllergiesConstants.RESET_STATE:
      return { ...initialPatientAllergiesState }
    default:
      return state
  }
}
